import styled, { keyframes } from "styled-components";

import { buttonColors, buttonSizes, iconButtonSizes } from "./constants";
import { ButtonColor, ButtonSize, ButtonVariant } from "./types";

const rotate = keyframes`
    from{ transform: rotate(0deg); }
    to{ transform: rotate(360deg); }
`;

export const RotatingContainer = styled.div`
  transform-origin: 50% 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${rotate} 1s linear infinite;
`;

const CommonButtonStyle = styled.button<{
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: ButtonSize;
}>(
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    transition: "all 200ms ease-in-out",
    fontWeight: 600,
    outlineWidth: 0,
    outlineOffset: 3,
    "&:disabled": { cursor: "not-allowed" },
    "&:focus": { outlineWidth: 2 },
  },
  ({ variant, color }) => {
    const theme = buttonColors[color][variant];
    return {
      ...theme.normal,
      "&:not(:disabled):hover": theme.hover,
      "&:not(:disabled):active": theme.active,
      "&:not(:disabled):focus": theme.focus,
      "&:disabled": theme.disabled,
    };
  }
);

export const ButtonStyle = Object.assign(
  styled(CommonButtonStyle)(({ size }) => buttonSizes[size]),
  { RotatingContainer: RotatingContainer }
);

export const IconButtonStyle = Object.assign(
  styled(CommonButtonStyle)(({ size }) => iconButtonSizes[size]),
  { RotatingContainer: RotatingContainer }
);
